import styled, { css } from 'styled-components';
import Button from '@components/atoms/button/button';

type FeedbackButtonContainerProps = {
  open: boolean;
  $isMobile: boolean;
};

export const FeedbackButtonContainer = styled.div<FeedbackButtonContainerProps>`
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0em;
  text-align: center;

  ${({ open }) => {
    if (!open) {
      return css`
        display: inline-flex;
        padding: 0 30px 0 30px;
        gap: 10px;
        align-items: center;
        border-radius: 3px;
        transition: ease-in-out;
      `;
    } else {
      return css`
        padding: 6px;
        align-items: center;
        border-radius: 3px;
        transition: ease-in-out;
      `;
    }
  }}
`;

export const StyledButton = styled(Button)`
  position: fixed;
  display: flex;
  top: ${({ theme }) => theme.position.desktop.top};
  right: ${({ theme }) => theme.position.desktop.right};
  bottom: ${({ theme }) => theme.position.desktop.bottom};
  left: ${({ theme }) => theme.position.desktop.left};

  ${({ $isMobile }) => {
    if ($isMobile) {
      return css`
        height: 44px;
        width: 44px;
        border-radius: 30px;
        top: ${({ theme }) => theme.position.mobile.top};
        right: ${({ theme }) => theme.position.mobile.right};
        bottom: ${({ theme }) => theme.position.mobile.bottom};
        left: ${({ theme }) => theme.position.mobile.left};
        justify-content: center;
        align-items: center;
      `;
    }
  }}
`;
